import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mockup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hero_layer = _resolveComponent("hero-layer")!
  const _component_hero_content = _resolveComponent("hero-content")!
  const _component_hero_image = _resolveComponent("hero-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_hero_layer),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_hero_content),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_hero_image)
        ])
      ])
    ])
  ]))
}